import React, { useEffect, useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTelegram,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
const DesktopFooter = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://api.worldlibertyfinancialltd.com/api/admin/site/setting/social/support/view`
      )
      .then((res) => {
        setData(res?.data?.data);
      })
      .catch((err) => {
        // console.log("API call error:", err?.message);
      });
  }, []);
  return (
    <>
      <footer className="text-uppercase">
        <section className="bg-color-gray py-4 py-lg-3">
          <div className="container mw-1480">
            <div className="row">
              <div className="col-12 col-lg-122 align-self-center">
                <ul
                  className="nav display-size-08vw justify-content-center  mt-lg-3 font-slatepro"
                  aria-label="Footer Menu"
                >
                 
                  <li className="nav-item">
                    <Link
                      className="mx-2 mx-lg-0 mr-0 mr-lg-3 mb-2 d-block color-black-link no-underline"
                      to="/about/us"
                    >
                     About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="mx-2 mx-lg-0 mr-0 mr-lg-3 mb-2 d-block color-black-link no-underline"
                      to="/who-we-are/our-purpose"
                    >
                      Our Purpose
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="mx-2 mx-lg-0 mr-0 mr-lg-3 mb-2 d-block color-black-link no-underline"
                      to="/who-we-are/sustainability-data--trading-insights3"
                    >
                     Sustainability Data & Trading Insights
                    </Link>
                  </li>
                 
                  <li className="nav-item">
                    <Link
                      className="mx-2 mx-lg-0 mr-0 mr-lg-3 mb-2 d-block color-black-link no-underline"
                      to="/privacy/policy"
                    >
                      Privacy Policy
                    </Link>
                  </li>
                  
                  <li className="nav-item">
                    <Link
                      className="mx-2 mx-lg-0 mr-0 mr-lg-3 mb-2 d-block color-black-link no-underline"
                      to="/terms-of-use"
                    >
                      Terms of Use
                    </Link>
                  </li>
                 
                </ul>
              </div>
              {/* <div className="col-12 col-lg-3 align-self-center mt-3 mt-lg-0">
                <ul
                  className="nav justify-content-center justify-content-lg-end social-links"
                  aria-label="Social links"
                >
                  <li className="nav-item">
                    <a
                      className="ml-3"
                      href={data?.telegram_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faTelegram} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="ml-3" href="" target="_blank">
                      <FontAwesomeIcon icon={faTwitter} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="ml-3" href="" target="_blank">
                      <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="ml-3" href="" target="_blank">
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
        </section>
        <section className="position-relative">
          <div className="container mw-1480 py-4">
            <div className="row">
              <div className="col-12 display-size-14 display-size-14-sm text-center color-black font-slatepro COPYRIGHT">
                COPYRIGHT © 2025WLF Mobile. ALL
                RIGHTS RESERVED
              </div>
            </div>
          </div>
        </section>
      </footer>
    </>
  );
};

export default DesktopFooter;
